import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { ref, onValue, off } from 'firebase/database';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let userUnsubscribe = null;
    let adminUnsubscribe = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      // Clean up previous listeners
      if (userUnsubscribe) userUnsubscribe();
      if (adminUnsubscribe) adminUnsubscribe();

      setCurrentUser(user);

      if (user) {
        const userRef = ref(db, 'users/' + user.uid);
        const adminRef = ref(db, 'admins/' + user.uid);

        let userData = null;
        let adminData = null;

        const syncProfile = () => {
          let profileData = {};
          if (userData) profileData = { ...userData };
          if (adminData) {
            profileData = {
              ...profileData,
              isAdmin: true,
              adminId: adminData.adminId,
              role: adminData.role,
              email: adminData.email,
              name: adminData.name || profileData.name
            };
          }
          
          if (Object.keys(profileData).length > 0) {
            setUserProfile(profileData);
          } else {
            setUserProfile(null);
          }
        };

        // Real-time listener for User Profile
        userUnsubscribe = onValue(userRef, (snapshot) => {
          const data = snapshot.exists() ? snapshot.val() : null;
          userData = data;
          syncProfile();
          setLoading(false);
        }, (error) => {
          console.error("Firebase read error on user profile:", error);
          setLoading(false); // Unblock app rendering even if read fails
        });

        // Real-time listener for Admin Status
        adminUnsubscribe = onValue(adminRef, (snapshot) => {
          adminData = snapshot.exists() ? snapshot.val() : null;
          syncProfile();
        }, (error) => {
          console.error("Firebase read error on admin status:", error);
        });

      } else {
        setUserProfile(null);
        setLoading(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (userUnsubscribe) userUnsubscribe();
      if (adminUnsubscribe) adminUnsubscribe();
    };
  }, []);

  const value = {
    currentUser,
    userProfile,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#0a0a0a', color: '#00e5ff', fontFamily: 'monospace' }}>
          INITIALIZING SECURE CONNECTION...
        </div>
      ) : children}
    </AuthContext.Provider>
  );
}
